



























































import { Component, Prop, Mixins, Watch } from "vue-property-decorator"
import QuestionMixins from "@/mixins/QuestionMixins"
import QQuestionAnswer from "@/components/QQuestionAnswer.vue"
import { mapState, mapMutations } from "vuex"
import _ from "lodash"

@Component({
  components: {
    QQuestionAnswer
  },
  computed: {
    ...mapState("QuestionnaireAnswer", {
      questionGroupIndex: "questionGroupIndex",
      onboarding: "onboarding"
    })
  },
  methods: {
    ...mapMutations("QuestionnaireAnswer", {
      setQuestionGroupIndex: "SET_QUESTION_GROUP_INDEX"
    })
  }
})
export default class QQuestionnaireResultLayout extends Mixins(QuestionMixins) {
  @Prop() readonly questionGroups!: QuestionGroup[]
  @Prop({ default: "dark" }) readonly mode!: string
  @Prop({ default: false }) readonly showQgDescription!: boolean
  @Prop({ default: false }) readonly disableQgTooltip!: boolean

  onboarding!: number
  questionGroupIndex!: number
  setQuestionGroupIndex!: (v: number) => void

  goTop() {
    this.$vuetify.goTo("#page-top", {
      container: this.$refs.scroller as Vue
    })
  }

  questionGroupClasses(group) {
    const maxWarningLevelNegativeRule =
      _.chain(group.questions)
        .flatMapDeep(question => {
          return question.question_answer?.negatives || []
        })
        .maxBy(item => parseInt(item.flag))
        .value()
    
    const style = maxWarningLevelNegativeRule?.flag ? maxWarningLevelNegativeRule?.flag - 1 : 0
    return "style-" + style
  }

  @Watch("onboarding")
  watchOnboarding(newVal, oldVal) {
    if (newVal !== oldVal && this.questionGroupIndex > -1) {
      this.jumpTo(this.questionGroupIndex)
      this.setQuestionGroupIndex(-1)
    }
  }
}
